import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import { FaInstagram } from 'react-icons/fa';
import { FiFacebook } from 'react-icons/fi';
import { useHistory, useParams } from 'react-router-dom';
import NewFormWizard from '../../components/formWizard/NewFormWizard';
import Layout from '../../components/layouts/Layout';
import http from '../../config/BaseUrl';


const SocialMediaEdit = () => {


    const { id } = useParams()
    const history = useHistory()
    const SocialMediaEdit = history.location.state.SocialMedia

    const [instagramToggle, setInstagramToggle] = useState(true);
    const InstagramToggle = () => setInstagramToggle(!instagramToggle)

    const [facebookToggle, setFacebookToggle] = useState(false);
    const FacebookToggle = () => setFacebookToggle(!facebookToggle)
    const [loading, setLoading] = useState(false);

    const { register, handleSubmit } = useForm({
        defaultValues: {
            email_message: SocialMediaEdit.email_message
        }
    })


    const handelSocialUpdate = async (data) => {

        const socialEvent = {
            instagram: instagramToggle,
            client_facebook: facebookToggle,
            email_message: data.email_message
        }

        try {
            setLoading(true)
            await http.post(`/event/social/update/${id}`, socialEvent).then((res) => {
                if (res) {
                    setLoading(false)
                    history.push(`/show/event/${SocialMediaEdit.event_id}`, 'Information Updated.')
                }
            })
        } catch (error) {

        }
    }

    return (
        <Layout>
            <NewFormWizard />
            <section className="mt-5">
                <form onSubmit={handleSubmit(handelSocialUpdate)}>
                    <div className="row justify-content-center">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="text-center col-12 col-ma-12">
                                            <div className="pb-4">
                                                <p className="mb-0 display-4 text-primary event-form-title">Social</p>
                                                <p className="mb-0 text-secondary">All your social account settings</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="my-3 row">
                                        {/* <div className="col-md-8">
                                            <div className="p-1 bg-white border radius-10">
                                                <textarea
                                                    {...register("email_message")}
                                                    className="form-control"
                                                    id=""
                                                    cols="30"
                                                    rows="3"
                                                    disabled={!instagramToggle}
                                                >
                                                </textarea>
                                            </div>
                                        </div> */}
                                        {/* <div className="col-md-4">
                                            <div onClick={InstagramToggle} className={`${instagramToggle === true ? 'active-primary' : ''} text-center cursor-pointer p-4 bg-white border radius-10`}>
                                                <p className="px-1 py-2 mb-0 font-size-14"><FaInstagram size={18} /> Instagram Text {instagramToggle === false ? 'Disable' : 'Enable'}</p>
                                            </div>
                                        </div> */}
                                    </div>

                                    <div className="my-3 row">
                                        <div className="col-md-8">
                                            <div className="p-1 bg-white border radius-10">
                                                <textarea
                                                    className="form-control"
                                                    id=""
                                                    cols="30"
                                                    rows="3"
                                                    disabled={!facebookToggle}
                                                >
                                                </textarea>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div onClick={FacebookToggle} className={`${facebookToggle === true ? 'active-primary' : ''} text-center cursor-pointer p-3 bg-white border radius-10`}>
                                                <p className="px-1 py-3 mb-0 font-size-14"> <FiFacebook size={18} /> Facebook Text {facebookToggle === false ? 'Disable' : 'Enable'} </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div className="my-5 row justify-content-center">
                        <div className="col-md-10 col-lg-8 col-xl-8">
                            <button type="submit" className="float-right px-5 btn btn-primary radius-30">
                                {loading ?
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Updating...
                                    </>
                                    : "Update"
                                }
                            </button>
                        </div>
                    </div>
                </form>
            </section>
        </Layout>
    )
}

export default SocialMediaEdit
